import Employee201FileContainer from "../../../Components/Workforce/201File";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const Employee201File = () => {
  const { user } = useAppSelector((state) => state.auth);

  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "201 File";
  }, []);

  const CRUDPermissions = {
    create: false,
    read: true,
    update: false,
    delete: false,
  };

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "hr-assistant", "recruiter"]}
      />

      {/* Main content */}
      <Employee201FileContainer access={CRUDPermissions} />
    </>
  );
};

export default Employee201File;
